export const UPDATE_ADMIN_COMMON_STATUS = "updateAdminCommonStatus"; // 更新管理员状态
export const SET_SAMPLE_GROUP_DETAIL = "setSampleGroupDetail"; // 设置样本分组

// export const UPDATE_CURRENT_GROUP_SAMPLES = "getCurrentGroupSamples";  // 当前小组负责的样本列表
// export const UPDATE_CURRENT_GROUP_MEMBERS = "getCurrentGroupMembers";  // 当前小组成员列表

export const UPDATE_CURRENT_GROUP_ID = "updateCurrentGroupId"; // 更新当前小组ID
export const UPDATE_CURRENT_LEADER_INFO = "updateCurrentLeaderInfo"; // 更新小组组长信息
export const SET_USER_DETAIL = "setUserDetail"; // 访员的状态
export const SET_SAMPLE_LABEL = "setSampleLabel"; // 样本的标签
// member.questionnaire
export const TOGGLE_QUESTIONNAIRE_CONTENTS = "toggleQuestionnaireContents";
export const SET_QUESTIONNAIRE_CONTENTS = "setQuestionnaireContents";
export const SET_QUESTIONNAIRE_QG_IDS_NOT_EMP = "setQuestionnaireQgIdsNotEmp";
export const SET_CURRENT_QUESTION_GROUP = "setCurrentQuestionGroup";
export const UPSERT_ANSWER = "upsertAnswer"; // 插入或更新答案
export const UPSERT_VALIDATED_ANSWER = "updateValidatedAnswer"; // 更新或插入已验证的答案
export const INIT_ANSWER_CACHE = "initAnswerCache";
export const TOGGLE_PRE_SUBMIT = "togglePrevSubmit";
export const INIT_VALIDATED_ANSWER_CACHE = "initValidatedAnswerCache";
export const TOGGLE_CACHE_LOCK = "toggleCacheLock";

// member["member-status"]
export const UPDATE_MEMBER_COMMON_STATUS = "updateMemberCommonStatus"; // 更新访员的公共状态
